export default "__VITE_PUBLIC_ASSET__dcdb2133__"